import { render } from "./InfoCard.vue?vue&type=template&id=012c6544&scoped=true"
import script from "./InfoCard.vue?vue&type=script&lang=js"
export * from "./InfoCard.vue?vue&type=script&lang=js"

import "./InfoCard.vue?vue&type=style&index=0&id=012c6544&scoped=true&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012c6544"]])

export default __exports__